import React from 'react';
import TabLayout from '../components/TabLayout';
import { useTranslation } from 'react-i18next';

function MySubscriptions() {
    const { t } = useTranslation();
    return (
        <TabLayout title={t('tabs.mySubscriptions') || 'My Subscriptions'}>
            <div className="p-4">
                {/* Контент для My Subscriptions */}
            </div>
        </TabLayout>
    );
}

export default MySubscriptions;
